import { IonIcon } from "@ionic/react";
import { trashBinOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { devices } from "../../Devices";
import PremiumContentProtectiveLayer from "./PremiumContentProtectiveLayer";

const Container = styled.div`
  position: relative;
  .protective-layer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 1rem;
    button {
      font-size: 1rem;
      width: 100%;
      padding: 0.8rem 0;
    }
  }
`;

const EncarteStyle = styled.div`
  width: 15rem;
  height: 18rem;
  align-self: end;
  //box-shadow: 0px 15px 30px rgba(1, 1, 1, 0.1);
  cursor: pointer;
  transition: transform 300ms ease-in-out;
  &:hover {
    &:after {
      opacity: 1;
    }
  }
  position: relative;
  .icon {
    position: absolute;
    top: 1rem;
    left: 1rem;
    font-size: 2rem;
    color: #fff;
  }

  .icon:hover {
    color: red;
  }

  ${({ url, name, showTag, onClick }) => {
    return css`
      background-image: url("${url}");
      background-size: cover;
      ${!onClick && `cursor: default;`}
      &::after {
        transition: all 200ms ease-in;
        width: 100%;
        content: "${name}";
        text-align: center;
        top: 100%;
        position: absolute;
        transform: translateY(-100%);
        background-color: rgba(1, 1, 1, 0.5);
        opacity: 1;
        padding: 1rem 0;
        color: #fff;
        font-size: 1.2rem;
        text-transform: capitalize;
        line-height: 1.3;
      }

      ${showTag &&
      `&::before {
        content: "PREMIUM";
        position: absolute;
        top: 10%;
        left: 20%;
        width: 100%;
        transform: rotate(45deg);
        background-color: #d97706;
        height: 3rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 2px;;
        }`}
      overflow: hidden;
    `;
  }}

  @media ${devices.mobileL} {
    width: 14.1rem;
    height: 17rem;
  }
`;
export default function EncarteCard({
  url,
  name,
  onClick,
  isIncludedInPlan,
  showPremiumTag,
  className,
}) {
  const [showProtectiveLayer, setShowProtectiveLayer] = useState(false);
  const hasOnClick = typeof onClick === "function";
  const hasAccess = isIncludedInPlan === true;

  const handleBlockedInteraction = () => {
    if (!hasAccess && hasOnClick) setShowProtectiveLayer(true);
  };

  return (
    <Container
      onMouseEnter={handleBlockedInteraction}
      onTouchStart={handleBlockedInteraction}
      onMouseLeave={() => {
        if (!hasAccess && hasOnClick) setShowProtectiveLayer(false);
      }}
      onTouchEnd={() => {
        if (!hasAccess && hasOnClick) setShowProtectiveLayer(false);
      }}
      onClick={() => {
        if (hasAccess && hasOnClick) onClick();
      }}
    >
      {showProtectiveLayer && (
        <PremiumContentProtectiveLayer className="protective-layer" />
      )}
      <EncarteStyle
        className={className}
        url={url}
        name={name}
        showTag={showPremiumTag}
        onClick={undefined}
      ></EncarteStyle>
    </Container>
  );
}
